const { AchievementValidator, MatchStatuses } = require('../../types');

const checkNotSystem = (validators) => {
  validators.push({
    type: AchievementValidator.IS_NOT_SYSTEM,
  });
};

const checkMinBetOdds = (validators, minBetOdds) => {
  if (minBetOdds) {
    validators.push({
      type: AchievementValidator.IS_ODD_GREATER_OR_EQUAL_THAN,
      parameters: minBetOdds,
    });
  }
};

const checkMinPlacedAmount = (validators, minPlacedAmount) => {
  if (minPlacedAmount) {
    validators.push({
      type: AchievementValidator.IS_BET_AMOUNT_GREATER_OR_EQUAL_THAN,
      parameters: minPlacedAmount,
    });
  }
};

const checkBetCents = (validators, betCents) => {
  if (betCents) {
    validators.push({
      type: AchievementValidator.IS_BET_CENTS_VALID,
      parameters: betCents,
    });
  }
};

const checkEligiblePeriod = (validators, eligiblePeriod) => {
  if (eligiblePeriod) {
    validators.push({
      type:
        eligiblePeriod === MatchStatuses.LIVE
          ? AchievementValidator.IS_LIVE
          : AchievementValidator.IS_PREMATCH,
    });
  }
};

const checkStartingBeforeMaxStartDate = (validators, maxStartDate) => {
  if (maxStartDate) {
    validators.push({
      type: AchievementValidator.IS_STARTING_BEFORE_MAX_START_DATE,
      parameters: maxStartDate,
    });
  }
};

const checkStartingAfterMinStartDate = (validators, minStartDate) => {
  if (minStartDate) {
    validators.push({
      type: AchievementValidator.IS_STARTING_AFTER_MIN_START_DATE,
      parameters: minStartDate,
    });
  }
};

const checkAllowedMatchIds = (validators, matchIds) => {
  if (matchIds && matchIds.length) {
    validators.push({
      type: AchievementValidator.IS_MATCH_ID_VALID,
      parameters: matchIds,
    });
  }
};

const checkAllowedTournamentIds = (validators, tournamentIds) => {
  if (tournamentIds && tournamentIds.length) {
    validators.push({
      type: AchievementValidator.IS_TOURNAMENT_ID_VALID,
      parameters: tournamentIds,
    });
  }
};

const checkAllowedCategoryIds = (validators, categoryIds) => {
  if (categoryIds && categoryIds.length) {
    validators.push({
      type: AchievementValidator.IS_CATEGORY_ID_VALID,
      parameters: categoryIds,
    });
  }
};

const checkAllowedSportIds = (validators, sportIds) => {
  if (sportIds && sportIds.length) {
    validators.push({
      type: AchievementValidator.IS_SPORT_ID_VALID,
      parameters: sportIds,
    });
  }
};

const checkAllowedBetTypeIds = (validators, betTypeIds) => {
  if (betTypeIds && betTypeIds.length) {
    validators.push({
      type: AchievementValidator.IS_BET_TYPE_VALID,
      parameters: betTypeIds,
    });
  }
};

const checkExcludedBetTypeIds = (validators, betTypeIds) => {
  if (betTypeIds && betTypeIds.length) {
    validators.push({
      type: AchievementValidator.HAS_NO_BET_TYPES_IN,
      parameters: betTypeIds,
    });
  }
};

const checkExcludedSportIds = (validators, sportIds) => {
  if (sportIds && sportIds.length) {
    validators.push({
      type: AchievementValidator.HAS_NO_SPORTS_IN,
      parameters: sportIds,
    });
  }
};

const checkExcludedTournamentIds = (validators, tournamentIds) => {
  if (tournamentIds && tournamentIds.length) {
    validators.push({
      type: AchievementValidator.HAS_NO_TOURNAMENTS_IN,
      parameters: tournamentIds,
    });
  }
};

const checkExcludedCategoryIds = (validators, categoryIds) => {
  if (categoryIds && categoryIds.length) {
    validators.push({
      type: AchievementValidator.HAS_NO_CATEGORIES_IN,
      parameters: categoryIds,
    });
  }
};

const checkExcludedMatchIds = (validators, matchIds) => {
  if (matchIds && matchIds.length) {
    validators.push({
      type: AchievementValidator.HAS_NO_MATCHES_IN,
      parameters: matchIds,
    });
  }
};

const checkExcludeOutrightButBoostedOdds = (validators, excludeOutrightButAllowedBoostedOdds) => {
  if (excludeOutrightButAllowedBoostedOdds) {
    validators.push({
      type: AchievementValidator.HAS_NO_OUTRIGHT_BUT_BOOSTED_ODDS,
    });
  }
};

const checkUsingFreebet = (validators, hasFreebet) => {
  if (typeof hasFreebet === 'boolean') {
    validators.push({
      type: AchievementValidator.HAS_FREEBET,
      parameters: hasFreebet,
    });
  }
};

const checkHasBoostedOdd = (validators, hasBoostedOdd) => {
  if (typeof hasBoostedOdd === 'boolean') {
    validators.push({
      type: AchievementValidator.HAS_BOOSTED_ODDS,
      parameters: hasBoostedOdd,
    });
  }
};

const checkHasOutright = (validators, hasOutright) => {
  if (typeof hasOutright === 'boolean') {
    validators.push({
      type: AchievementValidator.HAS_OUTRIGHT,
      parameters: hasOutright,
    });
  }
};

module.exports = {
  checkNotSystem,
  checkMinBetOdds,
  checkMinPlacedAmount,
  checkBetCents,
  checkEligiblePeriod,
  checkStartingBeforeMaxStartDate,
  checkStartingAfterMinStartDate,
  checkAllowedMatchIds,
  checkAllowedTournamentIds,
  checkAllowedCategoryIds,
  checkAllowedSportIds,
  checkAllowedBetTypeIds,
  checkExcludedBetTypeIds,
  checkExcludedSportIds,
  checkExcludedTournamentIds,
  checkExcludedCategoryIds,
  checkExcludedMatchIds,
  checkExcludeOutrightButBoostedOdds,
  checkUsingFreebet,
  checkHasBoostedOdd,
  checkHasOutright,
};
